import React, { Component } from 'react';
import styled from 'styled-components';

/** Custom import's */
import { Subscribe } from '../../store';
import t from '../../application/translate';
import { countries } from '../../containers/CountriesContainer';
import { isSchengenStore } from '../../containers/IsSchengenContainer';
import CountrySelector from '../CountrySelector';

const Wrapper = styled.div.attrs({
  className: 'bg-white w-full',
})``;

const InnerWrapper = styled.div.attrs({
  className: '',
})`
  max-width: 100%;
  min-width: 100%;
  padding: 40px;
  margin-left: auto;
  margin-right: auto;
  @media screen and (min-width: 425px) {
    max-width: 640px;
    min-width: 420px;
    padding: 90px 40px 110px 40px;
  }
  @media screen and (min-width: 768px) {
    padding: 90px 40px 20px 40px;
  }
`;

const Title = styled.div.attrs({
  className: 'text-center text-3xl font-semibold',
})``;

const FormDiv = styled.div.attrs({
  className: '',
})`
  width: 100%;
  padding: 0;
  margin: 0 auto;
  padding-bottom: 50px;
  @media screen and (min-width: 425px) {
    width: 340px;
    padding: 40px;
  }
  @media screen and (min-width: 768px) {
    padding-bottom: 40px;
  }
`;

const Result = styled.div.attrs({
  className: 'text-center text-xl xs:text-3xl font-semibold p-4 rounded-lg',
})`
  color: ${(props) => props.isSchengenStore.state.schengenColor};
  background-color: ${(props) =>
    props.isSchengenStore.state.schengenBgColor};
`;

const StyledCountrySelector = styled(CountrySelector)`
 
  label {
    padding-right: 22px;
  }

  .select {

    &__control {
      border-bottom: 1px solid #a2a2a2;
    }

    &__value-container {
      display: flex;
      justify-content: center;
    }
  }

  @media screen and (max-width: 425px) {
    margin-top: 30px !important;
    
  }
`;

type Props = {
  onChange: Function,
  destinations: DestinationType,
};

class IsSchengen extends Component<Props & ProvidedProps, State> {
  render() {
    const {
      language,
      countriesStore,
      isSchengenStore,
    } = this.props;
    const { destination, schengenResultID } = isSchengenStore.state || null;
    const { countries } = countriesStore.state || {};

    const {
      handleDestinationChange,
    } = isSchengenStore;
    const {
      getCountryByCode,
    } = countriesStore;

    return (
      <Wrapper>
        <InnerWrapper>
          <Title>{t('isSchengen/title')}</Title>
          <FormDiv>
            <StyledCountrySelector 
              id='destination'
              name='destination'
              value={destination ? destination.twoLetterCode : ''}
              countries={countries}
              onChange={value => {
                handleDestinationChange(getCountryByCode(value));
              }}
              language={language}
              placeholder={t('productParameters/destination/placeholder')}
            />
            
          </FormDiv>     
          {schengenResultID && (
            <Result {...this.props}>
              {t('isSchengen/result' + schengenResultID)}
            </Result>
          )}
        </InnerWrapper>
      </Wrapper>
    );
  }
}

const IsSchengenWrapper = (props) => {
  const { language } = props;
  return (
    <Subscribe to={[countries, isSchengenStore]}>
      {(countriesStore, isSchengenStore) => {
        const { countries, error, isFetching } = countriesStore.state;
        if(!countries.length && !error && !isFetching) {
          countriesStore.fetchCountries(language);
        }
        return (
          <IsSchengen
            countriesStore={countriesStore}
            isSchengenStore={isSchengenStore}
            {...props}
          />
        );
      }}
    </Subscribe>
  );
};

export default IsSchengenWrapper;



// WEBPACK FOOTER //
// ./src/components/IsSchengen/IsSchengen.js